export const syncType = {
  SYNC_ZONES: 'sync zones',
  SYNC_COUNTERS: 'sync counters',
}
